import React from "react";
import { CheckIcon, RefreshIcon } from "../Icons";
import { money } from "../business-case/calculator";
import { PromisePanel } from "../ui";

const TERMS = [
  {
    Icon: CheckIcon,
    tone: "tw-text-[#0f7a62]",
    text: "Monthly customers can cancel before their next billing cycle.",
  },
  {
    Icon: RefreshIcon,
    tone: "tw-text-[#087bd3]",
    text: "Annual customers receive an early-exit option; unused subscription months are non-refundable.",
  },
];

type Props = {
  promise: { hours: number; minimumParticipants: number; refund: number };
};

export default function PromiseBanner({ promise }: Props) {
  return (
    <section className="tw-bg-white tw-px-8 tw-py-20 sm:tw-px-5 sm:tw-py-12">
      {/* The gutter is the section's, not the card's: CONTAINER's padding would sit inside the
          rounded edge and expose the card background beside the blue panel. */}
      <div className="tw-mx-auto tw-grid tw-max-w-[1180px] tw-grid-cols-[.78fr_1.22fr] tw-overflow-hidden tw-rounded-[30px] tw-border tw-border-[#b9daef] tw-bg-[#eaf6fd] sm:tw-grid-cols-1">
        <PromisePanel>
          Less risk.
          <br />
          Less admin.
        </PromisePanel>

        <div className="tw-p-12 sm:tw-p-8">
          <h2 className="tw-m-0 tw-max-w-3xl tw-text-4xl tw-font-black tw-leading-[1.08] tw-tracking-[-.04em] tw-text-[#10233f] sm:tw-text-3xl">
            Save your team at least {promise.hours} hours on your next mentoring cohort—or we&rsquo;ll
            refund your {money(promise.refund)} standard setup fee.
          </h2>
          <p className="tw-mt-5 tw-mb-0 tw-max-w-3xl tw-text-lg tw-leading-8 tw-text-[#4c657d]">
            The promise applies to cohorts of {promise.minimumParticipants} or more participants when
            FutureLab is used across the agreed programme workflow and the administration baseline is
            confirmed before launch.
          </p>

          <div className="tw-mt-7 tw-grid tw-grid-cols-2 tw-gap-4 tw-border-t tw-border-[#bfd9e9] tw-pt-6 sm:tw-grid-cols-1">
            {TERMS.map(({ Icon, tone, text }) => (
              <div key={text} className="tw-flex tw-gap-3">
                <Icon aria-hidden className={`tw-mt-0.5 tw-h-5 tw-w-5 tw-shrink-0 ${tone}`} />
                <p className="tw-m-0 tw-text-sm tw-font-bold tw-leading-6 tw-text-[#304c67]">{text}</p>
              </div>
            ))}
          </div>

          <p className="tw-mt-5 tw-mb-0 tw-text-xs tw-leading-5 tw-text-[#5c7183]">
            Full eligibility, measurement and early-exit terms are confirmed in the customer proposal
            and service agreement.
          </p>
        </div>
      </div>
    </section>
  );
}
